import * as types from '../constants/ActionTypes';

export default function geod(state = {}, action) {
  switch (action.type) {

    case types.ACTIVATE_GEOD:
      return action.geod;

    case types.CLOSE_GEOD:
      return {

      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/scrollListReducer.js